import React, { useRef } from 'react';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
// import {
//   PiShareNetwork,
// } from 'react-icons/pi';
import {
  FaRegSave,
  FaRegFolderOpen,
  FaRegFile,
  FaRegClipboard,
} from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { setPhysics, setHighlightedNodes, setHighlightedEdges } from '../../features/networkSlice';
import { setNetwork, reset } from '../../features/networkUndoSlice';
import { parseNode, convertBlobToBase64 } from '../../lib/network/helpers';

export default function Handler() {
  const fileInputRef = useRef();

  const dispatch = useDispatch();

  // global state
  const nodes = useSelector((state) => state.networkUndo.present.nodes);
  const edges = useSelector((state) => state.networkUndo.present.edges);
  const meta = useSelector((state) => state.networkUndo.present.meta);

  const loadNetwork = (fileEvent) => {
    const file = fileEvent.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (onLoadEvent) => {
        try {
          dispatch(setPhysics(false));
          dispatch(setHighlightedNodes([]));
          dispatch(setHighlightedEdges([]));
          const model = JSON.parse(onLoadEvent.target.result);
          dispatch(setNetwork({
            nodes: model.nodes.map(parseNode) || [],
            edges: model.edges || [],
            meta: model.meta || { title: 'Untitled' },
          }));
        } catch (err) {
          // console.log(err);
        }
      };
      reader.readAsText(file);
    }
  };

  const base64EncodeLocalImages = async (node) => {
    if (node.image && node.image.startsWith('blob:http')) {
      const image = await convertBlobToBase64(node.image);
      return { ...node, ...{ image } };
    }
    return node;
  };

  const saveNetwork = async () => {
    // network.current.storePositions();
    // convert local images to base64
    const convertedNodes = await Promise.all(await nodes.map(base64EncodeLocalImages));
    const model = {
      nodes: convertedNodes,
      edges: edges.map(({ hidden, ...rest }) => rest), // "hidden" is used for toggling self effects
      meta,
    };
    const networkJSON = JSON.stringify(model, undefined, 2);
    const blob = new Blob([networkJSON], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'model.json';
    a.click();
    window.URL.revokeObjectURL(url);
  };

  // TODO: rewrite (simplify, human readable)
  const copyNetworkToClipboard = () => {
    if (window.isSecureContext) {
      const nodeIdToIndexMap = new Map(nodes.map((node, index) => [node.id, index]));
      const interactionMatrix = Array.from(
        { length: nodes.length },
        () => Array(nodes.length).fill(0),
      );
      const nodeLabels = nodes.map((node) => `'${node.label}'`).join(', ');
      edges.forEach((edge) => {
        const toIndex = nodeIdToIndexMap.get(edge.to);
        const fromIndex = nodeIdToIndexMap.get(edge.from);
        if (toIndex !== undefined && fromIndex !== undefined) {
          if (JSON.stringify(edge.arrows) === JSON.stringify({ to: { type: 'triangle' } })) {
            interactionMatrix[toIndex][fromIndex] = 1;
          } else if (JSON.stringify(edge.arrows) === JSON.stringify({ to: { type: 'circle' } })) {
            interactionMatrix[toIndex][fromIndex] = -1;
          }
        }
      });
      navigator.clipboard.writeText(
        `A = ${JSON.stringify(interactionMatrix)}\nlabels = [${nodeLabels}]`,
      );
    // } else {
    //   alert('"Copy to clipboard" is only available over HTTPS.');
    }
  };

  return (
    <>
      <ToggleButtonGroup size="small" sx={{ ml: 3 }}>
        <ToggleButton value="" title="New" onClick={() => dispatch(reset())}>
          <FaRegFile size="1.5em" />
        </ToggleButton>
        <ToggleButton value="" title="Open" onClick={() => fileInputRef.current.click()}>
          <FaRegFolderOpen size="1.5em" />
        </ToggleButton>
        <ToggleButton value="" title="Save" onClick={() => saveNetwork()}>
          <FaRegSave size="1.5em" />
        </ToggleButton>
        <ToggleButton value="" title="Copy to clipboard" onClick={() => copyNetworkToClipboard()}>
          <FaRegClipboard size="1.5em" />
        </ToggleButton>
        {/* <ToggleButton value="" title="Share">
          <PiShareNetwork size="1.5em" />
        </ToggleButton> */}
      </ToggleButtonGroup>
      <input
        ref={fileInputRef}
        type="file"
        accept=".json"
        onClick={(event) => {
          // eslint-disable-next-line
          event.target.value = null; // allow same file to be loaded (e.g after "New")
        }}
        onChange={loadNetwork}
        style={{ display: 'none' }}
      />
    </>
  );
}
